import * as _ from 'underscore';
import { Formatters, Messages } from '../../codegen/Localize';

export interface ISizeFilter {
  (sizeInBytes: number): string;
}

export enum ByteSizeConversionFactor {
  ONE_KB = 1000,
  ONE_MB = 1000000,
  ONE_GB = 1000000000,
}

// For details, see http://stackoverflow.com/questions/10015027/javascript-tofixed-not-rounding
function roundToPrecision(f: number, precision: number): number {
  const multiplier = Math.pow(10, precision + 1),
    wholeNumber = Math.floor(f * multiplier);
  return (Math.round(wholeNumber / 10) * 10 / multiplier);
}

function format(sizeInBytes: number, conversionFactor: ByteSizeConversionFactor) {
  return Formatters.formatFloat(roundToPrecision(sizeInBytes / conversionFactor, 1));
}

function sizeFilter(sizeInBytes: number): string {
  if(!_.isFinite(sizeInBytes) || sizeInBytes < 0) {
    return '';
  }
  if (sizeInBytes >= ByteSizeConversionFactor.ONE_GB) {
    return Messages.sizeInGB({
      SIZE_LOC: format(sizeInBytes, ByteSizeConversionFactor.ONE_GB),
    });
  }
  if (sizeInBytes >= ByteSizeConversionFactor.ONE_MB) {
    return Messages.sizeInMB({
      SIZE_LOC: format(sizeInBytes, ByteSizeConversionFactor.ONE_MB)
    });
  }
  if (sizeInBytes >= ByteSizeConversionFactor.ONE_KB) {
    return Messages.sizeInKB({
      SIZE_LOC: format(sizeInBytes, ByteSizeConversionFactor.ONE_KB)
    });
  }
  return Messages.sizeInBytes({
    SIZE_LOC: Formatters.formatCount(roundToPrecision(sizeInBytes, 0))
  });
}

export const SizeFilter: ISizeFilter = sizeFilter;
